module.exports = __webpack_public_path__ + "static/media/view floor.09ea131b.svg";